module.exports = __webpack_public_path__ + "static/media/Kotor_Muntenegru_1.1b3ec5b0.jpg";